var monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
var d = new Date();
var mesActual = monthNames[d.getMonth()].toUpperCase();
var anno = d.getFullYear() - 2000;
var annoEntero = d.getFullYear();

document.addEventListener('DOMContentLoaded', function () {
  var mesEl = document.getElementById('mes');
  if (mesEl) mesEl.textContent = mesActual;

  var annoEl = document.getElementById('anno_sufijo');
  if (annoEl) annoEl.textContent = anno;

  var footerAnnoEl = document.getElementById('anno_footer');
  if (footerAnnoEl) footerAnnoEl.textContent = anno;
});
